/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var notEmpty = function notEmpty(x) {
  return !!x;
};
var _default = function _default() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (args.length == 1 && Array.isArray(args[0])) {
    args = args[0];
  }
  return args.filter(notEmpty).join(' ');
};
exports.default = _default;